__turbopack_context__.v({
  "rich-text-container": "RichText-module-scss-module__yy0Hua__rich-text-container",
});
